import React, { FC } from 'react'
import { ExpeditionDetailGridItem } from '@typings/entities/Expedition'
import { DataCellProps } from '@mailstep/design-system/ui/Blocks/CommonGrid/types'
import { LinkInCell } from '@mailstep/design-system/ui/Blocks/CommonGrid'
import { Trans } from '@lingui/react'

type Props = DataCellProps<ExpeditionDetailGridItem>

export const SerialNumbersCell: FC<Props> = ({ rowData, onRowAction }) => {
  const handleShowSerialNumbersClick = React.useCallback(() => {
    onRowAction?.(rowData.id, 'showSerialNumbers', rowData)
  }, [rowData, onRowAction])

  if (!rowData.product.workAroundSnIn) {
    return null
  }

  return (
    <LinkInCell variant="medium" onClick={handleShowSerialNumbersClick} as="span">
      <Trans id="dataGrid.columnShowSerialNumbers.title" message="show serial numbers" />
    </LinkInCell>
  )
}
